// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip-root {
  display: flex;
}

.checkbox {
  min-height: 65px;
  display: flex;
  align-items: center;
}

i-checkbox ~ info-tooltip {
  margin-top: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/projects/controls/src/lib/base/field/field.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;;AAEA;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;AACJ;;AAEA;EACI,0BAAA;AACJ","sourcesContent":[".tooltip-root {\n    display: flex;\n}\n\n.checkbox {\n    min-height: 65px;\n    display: flex;\n    align-items: center;\n}\n\ni-checkbox ~ info-tooltip {\n    margin-top: 0px !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
